import { type ReactNode, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import styles from "../components/Review.module.css";
import { type Sent, SentNoticeContext, sentText } from "./sentNotice";

export const SentNoticeProvider = ({ children }: { children: ReactNode }) => {
  const [sent, setSent] = useState<Sent | null>(null);
  useEffect(() => {
    if (!sent) return;
    const timer = window.setTimeout(() => setSent(null), 8000);
    return () => window.clearTimeout(timer);
  }, [sent]);
  return (
    <SentNoticeContext.Provider value={setSent}>
      {children}
      {sent && (
        <div className={styles.sentNotice} role="status" data-review-chrome>
          <span>{sentText(sent)}</span>
          {sent.href && (
            <Link className={styles.link} to={sent.href}>
              Open the conversation
            </Link>
          )}
          <button
            type="button"
            className={styles.link}
            onClick={() => setSent(null)}
          >
            Dismiss
          </button>
        </div>
      )}
    </SentNoticeContext.Provider>
  );
};
